import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { TranslateModule } from '@ngx-translate/core'

import { ActionCardComponent } from './action-card.component'

@NgModule({
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    TranslateModule,
  ],
  exports: [
    ActionCardComponent,
  ],
  declarations: [
    ActionCardComponent,
  ],
  providers: [],
})
export class ActionCardModule { }
